import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlRestaurantData = (tableUid) => `${webUrlBase}api/mobile/restaurants/${tableUid}/table`;
export const urlCategories = `${webUrlBase}api/mobile/categories`;
export const urlRemoveUser = `${webUrlBase}api/mobile/table_orders/remove_user_order`;